var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTakenLeaves(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 16.5H39M13.3333 5.5V9.16667M31.6667 5.5V9.16667M11.5 22H15.1667M20.6667 22H24.3333M29.8333 22H33.5M11.5 27.5H15.1667M20.6667 27.5H24.3333M29.8333 27.5H33.5M11.5 33H15.1667M20.6667 33H24.3333M29.8333 33H33.5M11.8667 38.5H33.1333C35.1868 38.5 36.2137 38.5 36.998 38.1003C37.6879 37.7489 38.2489 37.1879 38.6003 36.498C39 35.7137 39 34.6868 39 32.6333V15.0333C39 12.9798 39 11.953 38.6003 11.1687C38.2489 10.4788 37.6879 9.91784 36.998 9.56631C36.2137 9.16667 35.1868 9.16667 33.1333 9.16667H11.8667C9.81315 9.16667 8.78637 9.16667 8.00204 9.56631C7.3121 9.91784 6.75117 10.4788 6.39965 11.1687C6 11.953 6 12.9798 6 15.0333V32.6333C6 34.6868 6 35.7137 6.39965 36.498C6.75117 37.1879 7.3121 37.7489 8.00204 38.1003C8.78637 38.5 9.81313 38.5 11.8667 38.5Z",
    stroke: "#3B82F6",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTakenLeaves);
export default __webpack_public_path__ + "static/media/takenLeaves.cac46994c8de7a7c33e077f765187a5f.svg";
export { ForwardRef as ReactComponent };